import { render, staticRenderFns } from "./SalesOverviewLoader.vue?vue&type=template&id=32ecbb66"
import script from "./SalesOverviewLoader.vue?vue&type=script&lang=ts"
export * from "./SalesOverviewLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports